//#region Imports
import { ABSERVICE_EXPERIMENTS } from "@anydo/ab-service";
import { getPlatformForApi } from "@anydo/core";
import { createAuthHeaders } from "./createAuthHeaders";
import { getReferral } from "./getReferral";
//#endregion

export function createAuthFetchLoginInput<
  T extends { client_id: string; locale: string; on_boarding_pending?: boolean },
>(rest: T) {
  return {
    method: "POST" as const,
    headers: createAuthHeaders(),
    body: JSON.stringify({
      platform: getPlatformForApi(),
      referrer: getReferral(),
      requested_experiments: ABSERVICE_EXPERIMENTS,
      create_predefined_data: {
        lists: true,
        label: true,
      },
      ...rest,
    }),
  };
}
